module.exports = __webpack_public_path__ + "media/images/diy/pinterest-137abdd4f5653631612868bcfa3257d8.svg";